import { type } from 'arktype'

import { languages } from '@orus.eu/translations'

export const certificateSearchSchema = type({
  'lg?': type('===', ...languages).or('undefined'),
})
